import images_01 from "../../../assets/images/home-page-room-01";
import images_02 from "../../../assets/images/home-page-room-02";
import images_03 from "../../../assets/images/home-page-room-03";
import images_04 from "../../../assets/images/home-page-room-04";
import images_05 from "../../../assets/images/home-page-room-05";
import images_06 from "../../../assets/images/home-page-room-06";


export const data = [
  {
    id: 1,
    type: "Căn hộ",
    status: "Bán",
    image: images_01,
    title: "Căn hộ cao cấp Vinhomes Central Park",
    location: "Quận Bình Thạnh, TP.HCM",
    price: "4.5 tỷ",
    area: "85m²",
    bedrooms: 2,
    bathrooms: 2,
  },
  {
    id: 2,
    type: "Biệt thự",
    status: "Bán",
    image: images_02,
    title: "Biệt thự đơn lập Ecopark",
    location: "Văn Giang, Hưng Yên",
    price: "12.8 tỷ",
    area: "250m²",
    bedrooms: 4,
    bathrooms: 3,
  },
  {
    id: 3,
    type: "Nhà phố",
    status: "Bán",
    image: images_03,
    title: "Nhà phố thương mại Times City",
    location: "Hai Bà Trưng, Hà Nội",
    price: "8.2 tỷ",
    area: "120m²",
    bedrooms: 3,
    bathrooms: 2,
  },
  {
    id: 4,
    type: "Căn hộ",
    status: "Cho thuê",
    image: images_04,
    title: "Căn hộ cao tầng The Sun Avenue",
    location: "Quận 2, TP.HCM",
    price: "25 triệu/tháng",
    area: "90m²",
    bedrooms: 2,
    bathrooms: 2,
  },
  {
    id: 5,
    type: "Đất nền",
    status: "Bán",
    image: images_05,
    title: "Đất nền view sông Hồng",
    location: "Long Biên, Hà Nội",
    price: "65 triệu/m²",
    area: "120m²",
     bedrooms: 2,
    bathrooms: 1,
  },
  {
    id: 6,
    type: "Penthouse",
    status: "Bán",
    image: images_06,
    title: "Penthouse Duplex Landmark 81",
    location: "Bình Thạnh, TP.HCM",
    price: "35 tỷ",
    area: "300m²",
    bedrooms: 4,
    bathrooms: 4,
  },
];